import { render, staticRenderFns } from "./uploadpz.vue?vue&type=template&id=5677b59e&scoped=true&"
import script from "./uploadpz.vue?vue&type=script&lang=js&"
export * from "./uploadpz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677b59e",
  null
  
)

export default component.exports